export default __webpack_public_path__ + "static/img_case_02-3aed9e387fbf6cfb753fcfbf1be95e61.webp";